import ClinicDepartmentService from "../../../../../../services/ClinicDepartmentService";
import DropDownService from "../../../../../../services/DropDownService";
import ProviderService from "../../../../../../services/ProviderService";
import ReferralProviderService from "../../../../../../services/ReferralProviderService";
import {
  fetchTimeInterval,
  getCurrentDate,
  getCurrentTime,
  isSet,
  optionsToKeyValuePairs,
} from "../../../../../../utils/commonUtils";
import { computationRules1 } from "./DrugScreenCollection";
export const fetchProviderList = async (val, props, callback = () => {}) => {
  const { employeeDetails } = props;
  let optionArr = [];
  try {
    const data = await ProviderService.getProviderByClinicId(
      employeeDetails.clinic_id,
      { perPage: 1000,
        page: 1,
        search: val }
    );
    isSet(data, []).map((item, itemIndex) => {
      optionArr.push({
        label: isSet(item.first_name, "") + " " + isSet(item.last_name, ""),
        value: item.provider_id,
        autoPopulateFields: {
          medical_examiners_license_certificate_or_registration_number:
            item.license,
          national_registry_number: item.dol_registry_id,
          medical_examiners_certificate_expiration_date:
            item.dol_registry_expires,
        },
        data: item,
        index: itemIndex,
      });
    });
    callback(optionArr);
  } catch (e) {}
  return optionArr;

};
export const fetchReferralProviderList = async (val, props, callback = () => {}) => {
  let optionArr = [];
  try {
    const response = await ReferralProviderService.getReferralProviders(null, {
      perPage: 1000,
      page: 1,
      search_query: val
    });
    if (response && response.data && Array.isArray(response.data)) {
      isSet(response.data, []).map((item, itemIndex) => {
        optionArr.push({
          label: `${isSet(item.first_name, "")} ${isSet(item.last_name, "")}${item.specialty ? ` (${item.specialty})` : ""}`.trim(),
          value: item.referral_provider_id,
          data: item,
          index: itemIndex,
        });
      });
    }
    callback(optionArr);
  } catch (e) {
    console.error('Error fetching referral providers:', e);
  }
  return optionArr;
};
export const NewXrayPanel = (props) => {
  console.log('XrayPanel props',props);
  const visitType = props.visitType ? props.visitType : '';
  const loggedInUsername =
    props?.profileDetails?.username ||
    props?.profileDetails?.name ||
    (props?.profileDetails?.first_name && props?.profileDetails?.last_name
      ? `${props.profileDetails.first_name} ${props.profileDetails.last_name}`
      : props?.profileDetails?.first_name || props?.profileDetails?.last_name || "");
  const radiologyChoiceOptions = props.radiologyChoiceOptions || [{ label: "-Select-", value: "" }];
  const radiologyOrderOptions = props.radiologyOrderOptions || [{ label: "-Select-", value: "" }];
  // Activity Status options based on visitType
  const activityStatusOptions = visitType==='WorkComp'
    ? ['Not Started', 'In Progress', 'Ordered', 'Ready for Review', 'Pending Provider Review', 'Completed', 'Cancelled']
    : ['Not Started', 'In Progress', 'Ordered', 'Pending Provider Review', 'Passed', 'Failed', 'Cancelled'];

  const stackedFieldStyle = {
    layout: 'stacked',
    showContainerBorder: false,
    labelWrap: false,
    isLabel: true,
  };
  const charts = [
    {
      type: "Grid",
      col: "col-md-3",
      data: [
        {
          type: "PatientDetails",
          employeeDetails: props.employeeDetails,
          visitDetails: props.visitDetails,
        },
        {
          type: "CompanyDetails",
          companyDetails: props.companyDetails,
        },
      ],
    },
    {
      type: "Tab",
      col: "col-md-9",
      data: [
        {
          id: "lab_order",
          label: "Radiology Order",
          data: [
            
            {
              label: "Xray Order Details",
              labelStyle: "fw-semibold",
              fields: [
                {
                  layout: 'stacked',
                  label:'Radiologist Choice',
                  col: 'col-6 border-0 ',
                  // type:'NewNumber',
                  placeholder:" Radiologist Choice ",
                  name:'referral_choice',
                  id:'referral_choice',
                  // rangeMax:139,
                  // rangeMin:90,
                  // Max:3,
                  required: false,
                  type: "SelectList",
                  options: radiologyChoiceOptions,
              },
              {
                type: "SelectList",
                options: radiologyOrderOptions,
                // options: [
                //   { label: "-Select-", value: "" },
                //   { label: "X-ray – Chest", value: "Xray_Chest" },
                //   { label: "X-ray – Abdomen", value: "Xray_Abdomen" },
                //   {
                //     label: "X-ray – Spine (Cervical / Thoracic / Lumbar)",
                //     value: "Xray_Spine",
                //   },
                //   { label: "X-ray – Pelvis", value: "Xray_Pelvis" },
                //   {
                //     label: "X-ray – Extremity (Arm / Leg / Wrist / Ankle)",
                //     value: "Xray_Extremity",
                //   },
                //   { label: "CT scan – Head", value: "CT_Head" },
                //   { label: "CT scan – Chest", value: "CT_Chest" },
                //   {
                //     label: "CT scan – Abdomen / Pelvis",
                //     value: "CT_Abdomen_Pelvis",
                //   },
                //   { label: "MRI – Brain", value: "MRI_Brain" },
                //   { label: "MRI – Spine", value: "MRI_Spine" },
                //   {
                //     label: "MRI – Joint (Knee / Shoulder / Hip)",
                //     value: "MRI_Joint",
                //   },
                //   {
                //     label: "Ultrasound – Abdomen",
                //     value: "Ultrasound_Abdomen",
                //   },
                //   {
                //     label: "Ultrasound – Pelvis",
                //     value: "Ultrasound_Pelvis",
                //   },
                //   {
                //     label: "Ultrasound – Thyroid",
                //     value: "Ultrasound_Thyroid",
                //   },
                //   {
                //     label: "Ultrasound – Doppler (Venous / Arterial)",
                //     value: "Ultrasound_Doppler",
                //   },
                //   {
                //     label: "Fluoroscopy – Barium Swallow",
                //     value: "Fluoroscopy_Barium_Swallow",
                //   },
                //   {
                //     label: "Mammography – Screening",
                //     value: "Mammography_Screening",
                //   },
                //   {
                //     label: "Mammography – Diagnostic",
                //     value: "Mammography_Diagnostic",
                //   },
                //   {
                //     label: "DEXA Scan – Bone Density",
                //     value: "DEXA_Bone_Density",
                //   },
                //   {
                //     label: "Nuclear Medicine – Whole Body / Organ Specific",
                //     value: "NuclearMedicine",
                //   },
                // ],

                label: "Radiology Order",
                className: "form-control form-control-solid ",
                name: "radiology_order",
                layout: 'stacked',
                col: 'col-6 border-0 ',
              },
                {
                  type: "Date",
                  label: "Test Date",
                  placeholder: "",
                  layout: 'stacked',
                  col: 'col-6 border-0 ',
                  className: "form-control form-control-solid",
                  name: "order_date",
                  required: true,
                },
                {
                  type: "SelectSearchList",
                  label: "Test Time",
                  placeholder: "Test Time",
                  layout: 'stacked',
                  col: 'col-6 border-0 ',
                  isAsync: true,
                  options: [
                    { label: getCurrentTime(), value: getCurrentTime() },
                  ],
                  loadCallBack: (val, callback) =>
                    fetchTimeInterval(val, callback),
                  className: "form-control form-control-solid",
                  name: "order_time",
                  required: true,
                },
              ],
            },
            {
              label: `Activity Details`,
              labelStyle: "fw-semibold",
              fields: [
                {
                  label: "Outside Radiologist ID",
                  layout: 'stacked',
                  col: 'col-6 border-0 ',
                  type: "TextInput",
                  name: "outside_radiologist_id",
                  id: "outside_radiologist_id",
                  placeholder: "Outside Radiologist ID",
                },
                {
                  label: "Sample ID",
                  layout: 'stacked',
                  col: 'col-6 border-0 ',
                  type: "TextInput",
                  name: "sample_id",
                  id: "sample_id",
                  placeholder: "Sample ID",
                },
                {
                  type: "Date",
                  label: "Result Date",
                  placeholder: "",
                  className: "form-control form-control-solid",
                  name: "result_date",
                  // required: true,
                  layout: 'stacked',
                  col: 'col-3 border-0 ',
                },
                {
                  type: "SelectSearchList",
                  label: "Result Time",
                  isAsync: true,
                  options: [
                    { label: getCurrentTime(), value: getCurrentTime() },
                  ],
                  loadCallBack: (val, callback) =>
                    fetchTimeInterval(val, callback),
                  className: "form-control form-control-solid",
                  name: "result_time",
                  // required: true,
                  layout: 'stacked',
                  col: 'col-3 border-0 ',
                },
                {
                  type: "Date",
                  label: "Received Date",
                  placeholder: "",
                  className: "form-control form-control-solid",
                  name: "received_date",
                  // required: true,
                  layout: 'stacked',
                  col: 'col-3 border-0 ',
                },
                {
                  type: "SelectSearchList",
                  label: "Received Time",
                  isAsync: true,
                  options: [
                    { label: getCurrentTime(), value: getCurrentTime() },
                  ],
                  loadCallBack: (val, callback) =>
                    fetchTimeInterval(val, callback),
                  className: "form-control form-control-solid",
                  name: "received_time",
                  // required: true,
                  layout: 'stacked',
                  col: 'col-3 border-0 ',
                },
              ],
            },
            {
              label: "Notes",
              labelStyle: "fw-semibold",
              fields: [
                {
                  label: "Notes",
                  col: "col-6",
                  type: "TextArea",
                  name: "notes",
                  layout: 'stacked',
                  col: 'col-12 border-0 ',
                  placeholder: "Notes",
                },
                {
                  type: "CheckBoxGroup",
                  label: "Actions",
                  isLabel: false,
                  isVertical: true,
                  col: "col-12 border-0",
                  showContainerBorder: false,
                  name: "xray_completed",
                  combineToKey:"xray_completed",
                  options: [
                    { name: "X-ray Complete", label: "X-ray Complete" },
                   ],
                },
                {
                  type: "InlineValueText",
                  col: "col-12 border-0",
                  labelPrefix: "Tech Name",
                  valueField: "xray_tech_name",
                  showWhenField: "xray_completed",
                },
              ],
            },
          ],
        },
        {
          id: "xray_results",
          label: "Results",
          data:[
            {
              label: "Initial Interpretation (wet read)",
              labelStyle: "fw-semibold",
              fields: [
                {
                  label: "Provider Name, MD/DO",
                  col: "col-6",
                  type: "SelectSearchList",
                  name: "provider_name",
                  isAsync: true,
                  loadCallBack: (val, callback) => fetchProviderList(val, props, callback),
                  options: [
                    // { label: "Provider Name", value: "Provider Name" },
                    // { label: "MD/DO", value: "MD/DO" },
                  ],
                  layout: 'stacked',
                  col: 'col-6 border-0 ',
                },
                {
                  label:"Date/Time Of Interpretation",
                  type: "Date",
                  placeholder: "",
                  layout: 'stacked',
                  col: 'col-6 border-0 ',
                  className: "form-control form-control-solid",
                  name: "initial_date_of_interpretation",
                },
                {
                  label:"Radiologist Findings",
                  type:"TextArea",
                  layout: 'stacked',
                  col: 'col-12 border-0 ',
                  name: "initial_radiology_findings",
                  id: 'initial_radiology_findings',
                  placeholder: "Radiologist Findings",
                },
                {
                  label: "Preliminary Findings (select one)",
                  type: "Label",
                  layout: 'stacked',
                  col: 'col-12 border-0 ',
                  name: "preliminary_findings",
                  id: 'preliminary_findings',
                  isBold:true,
                  fontBold:'400',
                  appendClassLabel:'text-left text-black text-md fw-bold opacity-100',
                },
                {
                  type: "radioBoxGroup",
                  name: "preliminary_findings",
                  isLabel: false,
                  isVertical: true,
                  col: "col-12 border-0",
                  showContainerBorder: false,
                  options: [
                    { value: "No Acute Osseous Abnormality Identified", label: "No Acute Osseous Abnormality Identified" },
                    { value: "Acute Fracture Identified", label: "Acute Fracture Identified" },
                    { value: "Suspected Fracture – Final Interpretation Pending", label: "Suspected Fracture – Final Interpretation Pending" },
                    { value: "Dislocation Identified", label: "Dislocation Identified" },
                    { value: "Subluxation Identified", label: "Subluxation Identified" },
                    { value: "Foreign Body Identified", label: "Foreign Body Identified" },
                    { value: "Degenerative Changes Noted (Incidental)", label: "Degenerative Changes Noted (Incidental)" },
                    { value: "Limited Exam – Definitive Interpretation Deferred", label: "Limited Exam – Definitive Interpretation Deferred" },
                    { value: "Normal", label: "Normal" },
                  ],
                },
                {
                  label: "Supporting Observations (optional)",
                  type: "Label",
                  layout: 'stacked',
                  col: 'col-12 border-0 ',
                  name: "supporting_observations",
                  id: 'supporting_observations',
                  isBold:true,
                  fontBold:'400',
                  appendClassLabel:'text-left text-black text-md fw-bold opacity-100',
                },
                {
                  type: "CheckBoxGroup",
                  label: "Actions",
                  isLabel: false,
                  isVertical: true,
                  col: "col-12 border-0",
                  showContainerBorder: false,
                  name: "supporting_observations",
                  combineToKey:"supporting_observations",
                  options: [
                    { name: "Soft Tissue Swelling", label: "Soft Tissue Swelling" },
                    { name: "Joint Effusion", label: "Joint Effusion" },
                    { name: "Alignment Grossly Maintained", label: "Alignment Grossly Maintained" },
                    { name: "Alignment Abnormal", label: "Alignment Abnormal" },
                    { name: "Overlying Artifact Present", label: "Overlying Artifact Present" },
                    { name: "Patient Motion Limits Evaluation", label: "Patient Motion Limits Evaluation" },
                  ],
                },
              ],
            },
            {
              label: "Final Interpretation (Radiology Over-Read) ",
              labelStyle: "fw-semibold",
              collapsible: true,
              defaultCollapsed: true,
              fieldProps: stackedFieldStyle,
              fields: [
                {
                  label: " Radiologist Name, MD/DO ",
                  col: "col-6",
                  type: "SelectSearchList",
                  name: "radiologist_name",
                  isAsync: true,
                  loadCallBack: (val, callback) => fetchReferralProviderList(val, props, callback),
                  options: [],
                  layout: 'stacked',
                  col: 'col-6 border-0 ',
                },
                {
                  label:"Date/Time Of Interpretation",
                  type: "Date",
                  placeholder: "",
                  layout: 'stacked',
                  col: 'col-6 border-0 ',
                  className: "form-control form-control-solid",
                  name: "final_date_of_interpretation",
                },
                {
                  label:"Radiologist Findings",
                  type:"TextArea",
                  layout: 'stacked',
                  col: 'col-12 border-0 ',
                  name: "radiology_findings",
                  id: 'radiology_findings',
                  placeholder: "Radiologist Findings",
                },
                {
                  label: "Final Impression (select ONE) ",
                  type: "Label",
                  // layout: 'stacked',
                  col: 'col-12 border-0 ',
                  name: "final_impression",
                  id: 'final_impression',
                  isBold:true,
                  fontBold:'400',
                  appendClassLabel:'text-left text-black text-md fw-bold opacity-100',
                },
                {
                    type: "radioBoxGroup",
                    name: "final_impression",
                    layout: 'horizontal',
                    isLabel: false,
                    isVertical: true,
                    col: "col-12 border-0",
                    showContainerBorder: false,
                    options: [
                      { value: "No Acute Osseous Abnormality", label: "No Acute Osseous Abnormality" },
                      { value: "Acute Fracture", label: "Acute Fracture" },
                      { value: "Subacute Or Healing Fracture", label: "Subacute Or Healing Fracture" },
                      { value: "Dislocation", label: "Dislocation" },
                      { value: "Subluxation", label: "Subluxation" },
                      { value: "Degenerative Joint Disease", label: "Degenerative Joint Disease" },
                      { value: "Foreign Body", label: "Foreign Body" },
                      { value: "Soft Tissue Abnormality", label: "Soft Tissue Abnormality" },
                      { value: "Post-Surgical Or Chronic Changes", label: "Post-Surgical Or Chronic Changes" },
                      { value: "Limited Exam", label: "Limited Exam" },
                      { value: "Normal", label: "Normal" },
                    ],
                },
                {
                  label: "Fracture Detail (Only If Applicable)",
                  type: "Label",
                  layout: 'stacked',
                  col: 'col-12 border-0 ',
                  name: "fracture_detail",
                  id: 'fracture_detail',
                  isBold:true,
                  fontBold:'400',
                  appendClassLabel:'text-left text-black text-md fw-bold opacity-100',
                },
                {
                  label:" Displacement: ",
                  type: 'radioBoxGroup',
                  name: 'displacement',
                  options: [
                    { label: 'Undisplaced', value: 'Undisplaced' },
                    { label: 'Displaced', value: 'Displaced' },
                  ],
                  col: 'col-6 border-0 ',
                  showContainerBorder: false,
                },
                {
                  label:"  Articular Involvement:",
                  type: 'radioBoxGroup',
                  name: 'articular_involvement',
                  options: [
                    { label: 'Yes', value: 'Yes' },
                    { label: '  No', value: 'No' },
                  ],
                  col: 'col-6 border-0 ',
                },
                {
                  label: "Comparison (Optional)",
                  type: "Label",
                  layout: 'stacked',
                  col: 'col-12 border-0 ',
                  name: "comparison",
                  id: 'comparison',
                  isBold:true,
                  fontBold:'400',
                  appendClassLabel:'text-left text-black text-md fw-bold opacity-100',
                },
                {
                  type: "radioBoxGroup",
                  name: "comparison",
                  isLabel: false,
                  isVertical: true,
                  col: "col-12 border-0",
                  showContainerBorder: false,
                  layout: 'horizontal',
                  options: [
                    { label: 'Compared To Prior Study (Date)', value: 'Compared To Prior Study (Date)' },
                    { label: 'No Prior Imaging Available ', value: 'No Prior Imaging Available' },
                  ],
                },

              ],
            },
            {
              label: "Review / Completion",
              labelStyle: "fw-semibold",
              SublabelStyle: "text-danger ",
              subLabel: "Signature is required to complete the activity status",
              fields: [ 
                  {
                      type: "ProviderSignOff",
                      col: "col-12",
                      fields: [
                          { label: "Signature PIN", name: "provider_pin", col: "col-12" },
                          { label: "Signature", type: "NewSignature", name: "provider_signature", col: "col-12" },
                          { label: "Date", type: "Date", name: "signed_date", col: "col-12" },
                          // { label : "Final Results", type: "SelectList", name: "status", col: "col-12", options: optionsToKeyValuePairs(['Not Started','Pending Result','Normal', 'Abnormal'],false),statusBasedColor:true},
                          // { label : "Activity Status", type: "SelectList", name: "activity_status", col: "col-12", options: optionsToKeyValuePairs(activityStatusOptions,false),statusBasedColor:true },
                          { label : "Final Results", type: "SelectList", name: "status", col: "col-12", options: optionsToKeyValuePairs(['Not Started','Pending','Normal','Abnormal','Negative','Positive','Dispensed','Administered','Failed','Passed','Non-Negative','Cancelled','Inconclusive'],false),statusBasedColor: true,},
                          { label : "Activity Status", type: "SelectList", name: "activity_status", col: "col-12", options: optionsToKeyValuePairs(['Not Started','Pending','Pending Lab Confirmation','Pending MRO Confirmation','Ready for Review','Completed','Cancelled'],false),statusBasedColor: true },
                      ],
                  },
              ],
          }

          ]
        },
        {
          id: "Images",
          label: "Images",
          data: []
        }
      ],
    },
  ];
  const defaultValue = {
    status: "Not Started",
    suggested_status: "Not Started",
    activity_status:'Not Started',
    // reason:'Pre-employment'
    order_date: getCurrentDate(),
    order_time: getCurrentTime(),
  };
  const buttons = {
    label: false,
    labreport: false,
    showTopUpdateButton: false,
    showLabTopActions: false,
  };
  const headers = [];
  return {
    charts,
    defaultValue,
    buttons,
    headers,
    computationFunction: (formData, key) => computationRulesForXrayPanel(formData, key, loggedInUsername),
  };
};
const computationRulesForXrayPanel = (formData, key, loggedInUsername = "") => {
  let returnResult = {};
  const currentStatus = isSet(formData.status, "Not Started");
  const currentActivityStatus = isSet(formData.activity_status, "Not Started");
  const xrayCompletedValue = formData.xray_completed;
  const isXrayCompletedChecked = Array.isArray(xrayCompletedValue)
    ? xrayCompletedValue.length > 0
    : typeof xrayCompletedValue === "string"
      ? xrayCompletedValue.trim() !== ""
      : !!xrayCompletedValue;
  if (currentStatus === "Not Started" && currentActivityStatus === "Not Started" && key==='referral_choice') {
    returnResult.status = "Pending";
    returnResult.activity_status = "Pending";
  }
  if (key === 'xray_completed' && isXrayCompletedChecked) {
    returnResult.status = 'Pending';
    returnResult.activity_status = 'Ready for Review';
    returnResult.xray_tech_name = loggedInUsername;
  } else if (key === 'xray_completed' && !isXrayCompletedChecked) {
    returnResult.activity_status = 'Pending';
    returnResult.xray_tech_name = "";
  }

  if(key === 'status' && formData.status) {
    const status = formData.status;
    // Check if provider has signed (medical_examiner_signature_two exists and is not empty)
    const providerSigned = formData.provider_signature && 
                          formData.provider_signature !== "" && 
                          formData.provider_signature !== null && 
                          formData.provider_signature !== undefined;
    
    switch(status) {
        case 'Not Started':
            returnResult.activity_status = 'Not Started';
            break;
        case 'Pending':
            returnResult.activity_status = 'Pending';
            break;
        case 'Normal':
            // If provider signed, set to Completed; otherwise Pending
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Abnormal':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Negative':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Positive':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Dispensed':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Administered':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Failed':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Passed':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Non-Negative':
            returnResult.activity_status = 'Pending Lab Confirmation';
            break;
        case 'Cancelled':
            returnResult.activity_status = 'Cancelled';
            break;
        case 'Inconclusive':
            returnResult.activity_status = 'Pending Lab Confirmation';
            break;
        default:
            // No change if status doesn't match any case
            break;
    }
  }

  if(key === 'provider_signature' && formData.status) {
    const status = formData.status;
    const providerSigned = formData.provider_signature && 
                          formData.provider_signature !== "" && 
                          formData.provider_signature !== null && 
                          formData.provider_signature !== undefined;
    
    // Completion statuses that should become "Completed" when provider signs
    const completionStatuses = ['Normal', 'Abnormal', 'Negative', 'Positive', 'Dispensed', 'Administered', 'Failed', 'Passed'];
    
    if (completionStatuses.includes(status)) {
      returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
    }
  }

  return returnResult;
}
const computationRules = (formData, key, visitType) => {
  let returnResult = {};
  // if((key==='status' || key==='provider_signature' )&& (formData.status==='Normal' || formData.status==='Abnormal') && (formData.provider_signature==='' || formData.provider_signature===null || formData.provider_signature===undefined)){
  //   return {
  //     activity_status: 'Pending Provider Review'
  //   };
  // }
  // if(key==='status' && formData.status==='Not Started' ){
  //   return {
  //     activity_status: 'Not Started'
  //   };
  // }
  // if(key==='status' && formData.status==='Pending Result' ){
  //   return {
  //     activity_status: 'In Progress'
  //   };
  // }
  // if(visitType==='WorkComp' && key==='status' && (formData.status==='Normal' || formData.status==='Abnormal') &&  formData.provider_signature!==""){
  //   return {
  //     activity_status: 'Completed'
  //   };
  // }
  // if(visitType!=='WorkComp' && key==='status' && formData.status==='Normal' &&  formData.provider_signature!==""){
  //   return {
  //     activity_status: 'Passed'
  //   };
  // }
  // if(visitType!=='WorkComp' && key==='status' && formData.status==='Abnormal' &&  formData.provider_signature!==""){
  //   return {
  //     activity_status: 'Failed'
  //   };
  // }
  // if(visitType==='WorkComp' && key==='provider_signature' && formData.provider_signature!=='' && (formData.status==='Normal' || formData.status==='Abnormal')){
  //   return {
  //     activity_status: 'Completed'
  //   };
  // }
  // if(visitType!=='WorkComp' && key==='provider_signature' && formData.provider_signature!=='' && formData.status==='Normal'){
  //   return {
  //     activity_status: 'Passed'
  //   };
  // }
  // if(visitType!=='WorkComp' && key==='provider_signature' && formData.provider_signature!=='' && formData.status==='Abnormal'){
  //   return {
  //     activity_status: 'Failed'
  //   };
  // }
  if (key === "status" || key === "activity_status") {
    return {};
  }
  const currentStatus = isSet(formData.status, "Not Started");
  const currentActivityStatus = isSet(formData.activity_status, "Not Started");
 

  // If user changes any field while both status and activity_status are "Not Started",
  // move to Pending Result / In Progress
  if (currentStatus === "Not Started" && currentActivityStatus === "Not Started" && key) {
    returnResult.status = "Pending";
    returnResult.activity_status = "Pending";
  }

  // If an xray result has been selected, override status/suggested_status
  // const xray = isSet(formData.xray, "");
  // if (xray !== "") {
  //   let finalStatus = "Passed";
  //   if (xray === "Abnormal") {
  //     finalStatus = "Failed";
  //   }
  //   returnResult.status = finalStatus;
  //   returnResult.suggested_status = finalStatus;
  // }

  return returnResult;
};
